import React, {useState, useEffect} from "react";
import axiosInstance from "../../../service/axiosInstance";
import {API_ENDPOINT} from "../../../config/config";
import { toast } from "react-toastify";
import {useSelector} from "react-redux";
import {selectUser} from "../../../app/features/user/userSlice";
import {
  EventList,
  SingleEvent,
} from "./DraftEvents.styles";
import {useNavigate} from "react-router-dom";


const MyEvents = () => {

  const {userInfo} = useSelector(selectUser);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate=useNavigate();


  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "-", time: "-" };
    const dateObj = new Date(dateString);
    const date = dateObj.toLocaleDateString("en-GB");
    const time = dateObj.toLocaleTimeString("en-US", { timeStyle: "short" }); // 👉 12:30 PM
    return { date, time };
  };


  const handleGetMyEvents = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get(
          `${API_ENDPOINT}event-config/?room_type=PRIVATE&user=${userInfo.id}`,
      );
      setEvents(response.data.results)
    } catch (err) {
      setError("Error fetching data. Please try again.");
      toast.error("Error fetching data!");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleGetMyEvents();
  }, []);

  return (
      <EventList>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {!loading && events.length === 0 && <p>No events found.</p>}
        {!loading &&
            events.map((event, index) => {
              const {date, time} = formatDateTime(event.selected_date_time);
              return (
                  <SingleEvent
                      key={event.id}>
                    <div className={"col"}>
                      <h5>Number</h5>
                      <p>{index + 1}</p>
                    </div>
                    <div className="col">
                      <h5>Room Type</h5>
                      <p>{event.room_type}</p>
                    </div>
                    <div className="col">
                      <h5>Date</h5>
                      <p>{date}</p>
                    </div>
                    <div className="col">
                      <h5>Rounds</h5>
                      <p>{event.rounds}</p>
                    </div>
                    <div className="col">
                      <h5>Team</h5>
                      <p>{event.team}</p>
                    </div>
                    <div className="col">
                      <h5>Time</h5>
                      <p>{time}</p>
                    </div>
                    <div className="col">
                      <h5>User</h5>
                      <p>{event.firstName}</p>
                    </div>
                    <button onClick={()=> navigate(`/waiting-room/${event.id}`)}>Enter the draft room</button>
                  </SingleEvent>
              )
            })}
      </EventList>
  );
};

export default MyEvents;

